import { atom } from 'jotai';
import { TUserDetail } from 'shared/models';

export const $SharerDetail = atom({} as TUserDetail);
$SharerDetail.debugLabel = '$SharerDetail';
